import { AUTOMATION_TRIGGER_CONFIGS } from 'pages/SmartConnectors/constants';

import { VARIABLE_DATA_TYPES } from 'ts-components/inputs/ValueInput/types';

import {
  AutomationTriggerConfig,
  CustomObjectLike,
  GenericOption,
  SmartVariableDataType,
} from 'pages/SmartConnectors/types';

import { TFunction } from 'react-i18next';
import { isContact } from 'utility/fieldHelpers';

export const getVariableTypeOptions = (
  customObject: CustomObjectLike | undefined,
  t: TFunction
): GenericOption<SmartVariableDataType>[] => {
  return [
    { value: VARIABLE_DATA_TYPES.uuid, label: t('UUID (Kizen ID)') },
    {
      value: VARIABLE_DATA_TYPES.string,
      label: t('String ({{name}})', {
        name: !isContact(customObject) ? t('Record Name') : t('Record Email'),
      }),
    },
  ];
};

export const getAutomationTriggerOptions = (
  t: TFunction
): GenericOption<AutomationTriggerConfig>[] => [
  { value: AUTOMATION_TRIGGER_CONFIGS.fire_all, label: t('All Triggers Fire') },
  {
    value: AUTOMATION_TRIGGER_CONFIGS.suppress_record_created,
    label: t('Suppress Record Create Triggers'),
  },
  {
    value: AUTOMATION_TRIGGER_CONFIGS.suppress_field_updated,
    label: t('Suppress Field Update Triggers'),
  },
  {
    value: AUTOMATION_TRIGGER_CONFIGS.suppress_all,
    label: t('Suppress All Triggers'),
  },
];
